export enum ForecastType {
    Waves = 0,
    Tides,
    Winds,
}